<div class="container" [ngClass]="{'avec-image': showBackgroundImage, 'sans-image': !showBackgroundImage}">
	<div class="logo">
		<lua-icone isIcon="true" mode="filled" [customIconName]="showBackgroundImage ? 'Logo_Couleur_T_Vertical' : 'Logo_Blanc_T_Vertical'" width="100%"
			height="100%"></lua-icone>
	</div>
</div>